<template>
        <div class="row g-3 position-relative">
            <h2 class="raised-label" v-if="fitter.mobile == 1">Your {{ fitter.mobile == 1 ? 'fitting address' : 'shipping' }} details</h2>
            <div class="col-12">
                <label for="same_as_billing" class="d-inline-block mb-3 cursor-pointer">
                    {{ fitter.mobile == 1 ? 'Fitting' : 'Shipping' }} address same as billing address?
                </label>
                <Field id="same_as_billing" name="same_as_billing" type="checkbox" class="d-inline-block ms-2 cursor-pointer" @click="toggleShipping"/>
                <shipping-fields
                    v-if="sameAsBilling == false && (fitter.mobile == 1 || this.$parent.$parent.basket.home_delivery == 1)"
                    :session-postcode="sessionPostcode"
                    :addresses="addresses"
                    :errors="errors"
                    @inputShippingAddressManually="this.$emit('inputShippingAddressManually')"
                ></shipping-fields>
            </div>
        </div>
</template>
<script>
    import { Field , ErrorMessage} from 'vee-validate';
    
    export default {
        props: ['fitter', 'sessionPostcode', 'addresses', 'sameAsBilling', 'errors'],
        emits: ['toggleShippingFields','inputShippingAddressManually'],
        components: { Field, ErrorMessage },
        data() {
            return {
            }
        },
        mounted() {

        },
        methods: {
            toggleShipping() {
                this.$emit('toggleShippingFields');
            }
        }
    }
</script>
<style lang="scss" scoped>

</style>